import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Driver = {
  id: string;
  full_name: string;
  phone: string;
  email: string;
  license_type: string;
  experience: string;
  region: string;
  additional_info?: string;
  verification_status: 'pending' | 'verified' | 'rejected';
  availability_status: 'available' | 'busy' | 'inactive';
  rating: number;
  total_jobs: number;
  created_at: string;
  updated_at: string;
};

export type Client = {
  id: string;
  contact_name: string;
  company?: string;
  phone: string;
  email: string;
  created_at: string;
  updated_at: string;
};

export type Request = {
  id: string;
  client_id: string;
  driver_type: string;
  duration: string;
  location: string;
  requirements?: string;
  status: 'pending' | 'matched' | 'confirmed' | 'completed' | 'closed' | 'cancelled';
  assigned_driver_id?: string;
  created_at: string;
  updated_at: string;
  clients?: Client;
  drivers?: Driver;
};

export type Payment = {
  id: string;
  request_id: string;
  client_id: string;
  driver_id: string;
  amount: number;
  driver_payment?: number;
  commission?: number;
  payment_status: 'pending' | 'paid' | 'overdue';
  payment_date?: string;
  created_at: string;
};

export type Issue = {
  id: string;
  request_id?: string;
  client_id?: string;
  driver_id?: string;
  issue_type: string;
  description: string;
  status: 'open' | 'in_progress' | 'resolved' | 'closed';
  assigned_staff_id?: string;
  resolution?: string;
  created_at: string;
  updated_at: string;
};

export type Staff = {
  id: string;
  full_name: string;
  email: string;
  role: 'admin' | 'verification_officer' | 'finance_officer' | 'customer_relations';
  permissions: string[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export type FinancialRecord = {
  id: string;
  assignment_id: string;
  record_type: 'driver_payment' | 'client_payment' | 'expense' | 'bonus';
  amount: number;
  description?: string;
  date: string;
  status: 'pending' | 'completed' | 'cancelled';
  receipt_url?: string;
  notes?: string;
  created_by?: string;
  created_at: string;
  updated_at: string;
};